/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Surface_AiInputs */

const en_marketing_surface_ai = /** @type {(inputs: Marketing_Surface_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI agent`)
};

const es_marketing_surface_ai = /** @type {(inputs: Marketing_Surface_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agente de IA`)
};

const fr_marketing_surface_ai = /** @type {(inputs: Marketing_Surface_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent IA`)
};

/**
* | output |
* | --- |
* | "AI agent" |
*
* @param {Marketing_Surface_AiInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_surface_ai = /** @type {((inputs?: Marketing_Surface_AiInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Surface_AiInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_surface_ai(inputs)
	if (locale === "es") return es_marketing_surface_ai(inputs)
	return fr_marketing_surface_ai(inputs)
});